import { parseURL, withoutTrailingSlash, withTrailingSlash } from 'ufo'

const NON_CANONICAL_ROUTES = new Set(['/', '/404'])
const NON_CANONICAL_PREFIXES = ['/_payload', '/product-details']

function isRedirectableRoute(routePath: string): boolean {
  return !NON_CANONICAL_ROUTES.has(routePath)
    && !NON_CANONICAL_PREFIXES.some(prefix => routePath.includes(prefix))
}

function toModelPath(modelUrl: string): string | null {
  if (typeof modelUrl !== 'string') {
    return null
  }

  const { pathname } = parseURL(modelUrl)
  return pathname.startsWith('/') ? pathname : `/${pathname}`
}

export function resolveCanonicalRedirect(routePath: string, modelUrl?: string | null): string | null {
  if (!routePath || !modelUrl || !isRedirectableRoute(routePath))
    return null

  const canonicalPath = toModelPath(modelUrl)

  if (!canonicalPath) {
    return null
  }

  const canonicalIsRoot = withoutTrailingSlash(canonicalPath) === '/'
  const routeIsAlreadyCanonical = withoutTrailingSlash(routePath) === withoutTrailingSlash(canonicalPath)

  if (canonicalIsRoot || routeIsAlreadyCanonical)
    return null

  return withTrailingSlash(canonicalPath)
}
